import { create } from "zustand";
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      userInfo: null,
      isLoggedIn: false,
      
      setToken: (token) => set({ 
        token,
        isLoggedIn: !!token 
      }),
      
      setUserInfo: (userInfo) => set({ userInfo }),
      
      updateUserInfo: (updatedInfo) => set({
        userInfo: { ...get().userInfo, ...updatedInfo }
      }),
      
      logout: () => set({ 
        token: null, 
        userInfo: null, 
        isLoggedIn: false 
      }),
    }),
    {
      name: 'auth-storage', // unique name for localStorage
    }
  )
);
